import React from 'react'
import { Mutation, graphql, compose } from 'react-apollo'
import { Button } from 'carbon-components-react'

import GetPlatformImages from '../hocs/queries/GetPlatformImages'
import { DO_REGISTER, DO_RESEND_VERIFICATION_EMAIL } from '../graphql/mutations'

import AppBranding from '../components/AppBranding'
import RegistrationForm from '../components/RegistrationForm'
import SSOButtons from '../components/SSOButtons'
import WithAlertModal from '../hocs/WithAlertModal'
import BackgroundImage from '../assets/images/veva-collect-default-download-image.jpg'

class Registration extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      completed: false,
      email: '',
      resending: false,
      resent: false,
      authenticating: false
    }

    this.resend = this.resend.bind(this)
  }

  resend() {
    if (this.state.resending) {
      return
    }

    this.setState({
      ...this.state,
      resending: true,
      resent: false
    })

    this.props
      .doResendVerificationEmail({
        variables: {
          email: this.state.email
        }
      })
      .then(() => {
        this.setState({
          ...this.state,
          resending: false,
          resent: true
        })
      })
      .catch(() => {
        this.props.alert('Unable to resend verification email')
      })
  }

  handleSSOSuccess = () => {
    // Store discount code if present from referral URL
    // (onboarding flag is set by SSOButtons based on isNewUser from backend)
    const code = this.props.match && this.props.match.params && this.props.match.params.code
    if (code) {
      localStorage.setItem('onboarding_discount_code', code)
    }
  }

  render() {
    let buttonText = 'Resend Verification Email'
    if (this.state.resending) {
      buttonText = 'Resending Verification Email...'
    } else if (this.state.resent) {
      buttonText = 'Resent Verification Email!'
    }

    const [image] = this.props.platformImages.filter(i => i.location === 'login')

    if (this.state.authenticating) {
      return (
        <div className='login'>
          <div className='loginFormBackground'>
            <div className='loginFormWrapper'>
              <AppBranding />
              <div className='loginForm sso-authenticating'>
                <div className='sso-authenticating__spinner' />
                <p className='sso-authenticating__text'>Setting up your account...</p>
              </div>
            </div>
          </div>
          <div className='loginBackground'>
            <img src={BackgroundImage} alt="Registration Page"/>
          </div>
        </div>
      )
    }

    return (
      <div className='login'>
        <div className='loginFormBackground'>
          <div className='loginFormWrapper'>
            <AppBranding />
            {this.state.completed && (
              <>
                <p
                  style={{
                    color: 'white'
                  }}
                >
                  Please check your emails for your verification email.
                </p>
                <br />
                <Button onClick={this.resend}>{buttonText}</Button>
              </>
            )}
            {!this.state.completed && (
              <>
                <div className='loginForm'>
                  <Mutation
                    mutation={DO_REGISTER}
                  >
                    {(doRegister, { loading, error }) => (
                      <RegistrationForm
                        onSubmit={state => {
                          doRegister({
                            variables: {
                              firstName: state.firstName,
                              lastName: state.lastName,
                              email: state.email,
                              password: state.password,
                              passwordConfirmation: state.passwordConfirmation
                            }
                          })
                            .then(response => {
                              if (!response.data.doRegister.success) {
                                this.props.alert('We could not create your account. Please try again.', {
                                  title: 'Account creation failed.'
                                })
                                return
                              }

                              // Store discount code for onboarding page after email verification
                              const code = this.props.match && this.props.match.params && this.props.match.params.code
                              if (code) {
                                localStorage.setItem('onboarding_discount_code', code)
                              }

                              // Flag that user needs onboarding after first login
                              localStorage.setItem('sso_needs_onboarding', 'true')

                              this.setState({
                                ...this.state,
                                email: state.email,
                                completed: true
                              })
                            })
                            .catch(() => {
                              //
                            })
                        }}
                        loading={loading}
                        errors={error}
                      />
                    )}
                  </Mutation>
                  <div className='sso-divider'>
                    <span className='sso-divider__line' />
                    <span className='sso-divider__text'>or</span>
                    <span className='sso-divider__line' />
                  </div>
                  <SSOButtons
                    mode='register'
                    onSuccess={this.handleSSOSuccess}
                    onAuthenticating={() => this.setState({ authenticating: true })}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className='loginBackground'>
          <img src={BackgroundImage} alt="Registration Page"/>
          {image && image.caption && <div className='loginBackgroundCredit'>{image.caption}</div>}
        </div>
      </div>
    )
  }
}

export default compose(
  WithAlertModal,
  GetPlatformImages,
  graphql(DO_RESEND_VERIFICATION_EMAIL, { name: 'doResendVerificationEmail' })
)(Registration)
